import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GastosIndexComponent } from './gastos-index/gastos-index.component';
import { GastosCreateComponent } from './gastos-create/gastos-create.component';
import { GastosUpdateComponent } from './gastos-update/gastos-update.component';
import { GastosViewComponent } from './gastos-view/gastos-view.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxKuvUtilsModule } from 'ngx-kuv-utils';
import { NgxKuvToolsModule } from 'ngx-kuv-tools';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule } from 'ngx-mask';
const routes: Routes = [
  { path: 'index', component: GastosIndexComponent },
  { path: '**', redirectTo: 'index' }
];


@NgModule({
  declarations: [
    GastosIndexComponent,
    GastosCreateComponent,
    GastosUpdateComponent,
    GastosViewComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    FormsModule,
    NgxKuvUtilsModule,
    NgxKuvToolsModule,
    NgSelectModule,
    NgxMaskModule.forChild()
  ]
    
  
})
export class GastosModule { }
